enum TimesheetUpdatedByTypeEnum {
  'TenantAdmin' = 'GravyWork Support',
  'CustomerAdmin' = 'Client Admin',
  'GravyWorkSystem' = 'Automatically',
}

export { TimesheetUpdatedByTypeEnum };
